import { objectsLoader } from '../behavior/objectsLoader-sidecar'
import { settings } from '../engine/settings-sidecar'
import { testRigCreator } from '../tests/testRigCreator-sidecar'
import { mapSaverShip } from '../tiles/mapSaverShip-sidecar'
import { tileMapEditor } from '../editor/tileMapEditor-sidecar'

const skipLoading = true

let isRunning = false
export const doRetry = () => {
  doPlay(settings.get().filename)
}

export const doPlay = (filename: string) => {
  isRunning = false

  const onRun = () => {
    isRunning = true
    tileMapEditor.setMode('test')
    testRigCreator.createTestRig()
  }

  if (skipLoading) {
    onRun()
  } else {
    mapSaverShip.loadNow(filename, () => {
      console.log('loaded level', filename)
      onRun()
      // objectsLoader.loadObjects()
    })
  }
}

export const update = () => {
  // if (tileMapEditor.getMode() !== 'test') {
  //   return
  // }
  if (!isRunning) {
    return
  }

  // let treasure = objects.getAllTreasure()
  // if (treasure.length === 0) {
  //   isRunning = false
  //   uiLevelFailed.open()
  // }

  // if (waves.areWavesDone()) {
  //   let enemies = l.filter(monsters.getAll(), (c) => c.team === 0)
  //   if (enemies.length === 0) {
  //     uiLevelWin.open()
  //   }
  //   //uiLevelFailed
  // }
}
